import React from "react";
import OrderManager from "./OrderManager";
import { OrdersContextProvider } from "../../Context/OrdersContext";
import { ProductsContextProvider } from "../../Context/ProductsContext";
import { useParams } from "react-router-dom";

const Order = () => {
  if (useParams().id === "nuevo") {
    return null;
  }
  return (
    <OrdersContextProvider>
      <ProductsContextProvider>
        <OrderManager></OrderManager>
      </ProductsContextProvider>
    </OrdersContextProvider>
  );
};

export default Order;
